import React from 'react';
import { CheckIcon, GiftIcon } from 'lucide-react';
import { CtaButton } from './CtaButton';
import { bonuses } from '../data/content';
export function BonusesSection() {
  return <section className="bg-cream px-4 py-14 sm:px-6 sm:py-20" data-id="element-37" data-mp="vsmmgn7suuc4">
      <div className="mx-auto w-full max-w-4xl" data-id="element-38" data-mp="vu7d41qztt4p">
        <p className="flex items-center justify-center gap-2 text-[10.5px] font-extrabold uppercase tracking-[0.2em] text-cta" data-id="element-39" data-mp="qtjqrtdpm0gt">
          <GiftIcon className="h-3.5 w-3.5" aria-hidden="true" data-id="element-40" data-mp="14rzwbgzu5kxd" />
          5 exclusive bonuses — free
        </p>

        <h2 className="mt-4 text-center text-[24px] font-black leading-tight tracking-tight text-navy sm:text-4xl" data-id="element-41" data-mp="zu7u9u5h8ifg">
          Today, you’ll also get these 5 professional bonuses at no extra cost
        </h2>

        <p className="mt-4 text-center text-[13px] font-extrabold uppercase tracking-[0.14em] text-navy2/70" data-id="element-42" data-mp="19mduts9so869">
          Total perceived value: $167
        </p>

        <div className="mt-10 space-y-6" data-id="element-43" data-mp="1jji812lnwtax">
          {bonuses.map(bonus => <article key={bonus.label} className="overflow-hidden rounded-3xl border border-navy/10 bg-white shadow-sm" data-id="element-44" data-mp="3pqtyqyx2onlp">
              <img src={bonus.image} alt={`${bonus.title} — included bonus materials`} className="block w-full bg-white" loading="lazy" data-id="element-45" data-mp="3ttqiwu29grrr" />

              <div className="px-5 pb-6 pt-5 sm:px-7" data-id="element-46" data-mp="ck1vp2r5thsy">
                <div className="flex flex-wrap items-center gap-2" data-id="element-47" data-mp="cja8ogbmosea">
                  <span className="rounded-full bg-navy px-3 py-1 text-[10.5px] font-extrabold uppercase tracking-[0.14em] text-white" data-id="element-48" data-mp="gklvke34azis">
                    {bonus.label}
                  </span>
                  <span className="rounded-full bg-skysoft px-3 py-1 text-[10.5px] font-extrabold uppercase tracking-[0.14em] text-cta" data-id="element-49" data-mp="qbgh1g8jhv36">
                    Value: {bonus.value}
                  </span>
                </div>

                <h3 className="mt-3.5 text-[19px] font-black uppercase leading-tight text-navy sm:text-2xl" data-id="element-50" data-mp="109w7ri3nn2c5">
                  {bonus.title}
                </h3>
                <p className="mt-2.5 text-[13.5px] leading-relaxed text-navy2 sm:text-[15px]" data-id="element-51" data-mp="5mnxpu35wy4n">
                  {bonus.description}
                </p>

                <p className="mt-5 text-[10.5px] font-extrabold uppercase tracking-[0.16em] text-navy2/70" data-id="element-52" data-mp="kcd4q5xxrwcu">
                  Includes:
                </p>
                <ul className="mt-3 grid gap-2 sm:grid-cols-2" data-id="element-53" data-mp="taxdofdp2rnv">
                  {bonus.items.map(item => <li key={item} className="flex items-start gap-2.5 rounded-xl bg-cream px-3 py-2.5" data-id="element-54" data-mp="obu88ttsyjfd">
                      <CheckIcon className="mt-0.5 h-4 w-4 shrink-0 text-cta" strokeWidth={3} aria-hidden="true" data-id="element-55" data-mp="yaa1b2ce42ri" />
                      <span className="text-[13px] font-semibold text-navy sm:text-sm" data-id="element-56" data-mp="302y81lo8t8c1">
                        {item}
                      </span>
                    </li>)}
                </ul>

                {bonus.footer ? <p className="mt-4 text-[13px] font-semibold italic text-navy2/80" data-id="element-57" data-mp="1klbd66zldl0v">
                    {bonus.footer}
                  </p> : null}
              </div>
            </article>)}
        </div>

        <div className="mx-auto mt-10 max-w-md" data-id="element-58" data-mp="wtw6k20s8hjt">
          <CtaButton label="Get all 5 bonuses free" subLabel="Included today with your $27 one-time payment" data-id="element-59" data-mp="ws31gr5ti5dx" />
        </div>
      </div>
    </section>;
}